import * as tester from './tester';

export const isMobileDevice = () => tester.isMobileDevice(navigator.userAgent);

export const isTabletDevice = () => tester.isTabletDevice(navigator.userAgent);

export const isMobileOrTabletDevice = () =>
  tester.isMobileOrTabletDevice(navigator.userAgent);

export const isAndroidDevice = () =>
  tester.isAndroidDevice(navigator.userAgent);

export const isIOSDevice = () => tester.isIOSDevice(navigator.userAgent);

export const getBrowserType = () => tester.browserType(navigator.userAgent);
